/*
  harm.icu // store runtime. Ported from the main site (lib/scramble.ts,
  lib/interactions.ts, components/Reticle.tsx) so the store behaves the same:
  1. Links and buttons scramble their label when hovered by a mouse (180ms).
  2. Fine pointers get the crosshair reticle with an X/Y readout; over links and
     buttons its corner brackets lock onto the target and it reads [TGT LOCK].
  Only interactive elements ever react. Everything stops under reduced motion,
  and the reticle never loads on touch.
*/
(function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* ---- scramble ------------------------------------------------------------ */

  var GLYPHS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789/<>[]#%&*+=:';
  var KEEP = { ' ': 1, '.': 1, '/': 1, ':': 1, '_': 1, '-': 1, '$': 1 };
  var jobs = new Map();

  function noise(final, from) {
    from = Math.max(0, Math.min(from, final.length));
    var out = final.slice(0, from);
    for (var i = from; i < final.length; i++) {
      var ch = final[i];
      out += KEEP[ch] ? ch : GLYPHS[(Math.random() * GLYPHS.length) | 0];
    }
    return out;
  }

  function scramble(el, duration) {
    var final = el.dataset.final || (el.dataset.final = el.textContent);
    var prev = jobs.get(el);
    if (prev) prev();
    if (!final.trim()) return;
    var perChar = duration / final.length;
    var start = performance.now();
    var raf = 0;
    var last = 0;
    function done() {
      cancelAnimationFrame(raf);
      jobs.delete(el);
      el.textContent = final;
    }
    function frame(now) {
      // rAF timestamps can predate performance.now() at start; a negative count made noise()
      // return a longer string for one frame, so the label widened and shoved its neighbours.
      // Same guard as lib/scramble.ts on the main site.
      if (now < start) {
        raf = requestAnimationFrame(frame);
        return;
      }
      if (now - last >= 40) {
        last = now;
        var n = Math.max(0, Math.floor((now - start) / perChar));
        if (n >= final.length) return done();
        el.textContent = noise(final, n);
      }
      raf = requestAnimationFrame(frame);
    }
    jobs.set(el, done);
    raf = requestAnimationFrame(frame);
  }

  // What scrambles inside a hovered link or button: explicit [data-scramble] labels,
  // otherwise the element itself when it holds nothing but a short line of text.
  function targets(el) {
    var marked = el.querySelectorAll('[data-scramble]');
    if (marked.length) return marked;
    var leaf = [];
    var walker = el.querySelectorAll('span, a, button');
    var pool = walker.length ? walker : [el];
    for (var i = 0; i < pool.length; i++) {
      var n = pool[i];
      if (n.children.length || n.closest('.visually-hidden')) continue;
      var t = (n.textContent || '').trim();
      if (t && t.length <= 40) leaf.push(n);
    }
    if (!walker.length && !el.children.length) {
      var own = (el.textContent || '').trim();
      if (own && own.length <= 40) leaf.push(el);
    }
    return leaf;
  }

  if (!reduced) {
    var last = null;
    document.addEventListener('pointerover', function (e) {
      if (e.pointerType !== 'mouse') return;
      var el = e.target && e.target.closest && e.target.closest('a[href], button');
      if (!el || el === last) return;
      last = el;
      if (el.closest('.harm-crt, .shopify-payment-button, [data-no-scramble]')) return;
      var list = targets(el);
      for (var i = 0; i < list.length; i++) scramble(list[i], 180);
    });
    document.addEventListener('pointerout', function (e) {
      var el = e.target && e.target.closest && e.target.closest('a[href], button');
      if (el && el === last && !el.contains(e.relatedTarget)) last = null;
    });
  }

  /* ---- pre-order countdown (html[data-store], snippets/harm-head.liquid) ----- */

  (function countdown() {
    var launch = window.HARM_LAUNCH;
    if (!launch || document.documentElement.dataset.store === 'live') return;
    function pad(n) {
      return String(n).padStart(2, '0');
    }
    function tick() {
      var s = Math.max(0, Math.floor((launch - Date.now()) / 1000));
      var text = 'T-' + pad(Math.floor(s / 86400)) + 'D ' + pad(Math.floor(s / 3600) % 24) + ':' + pad(Math.floor(s / 60) % 60) + ':' + pad(s % 60);
      document.querySelectorAll('[data-harm-countdown]').forEach(function (el) {
        el.textContent = text;
      });
      if (s === 0) {
        document.documentElement.dataset.store = 'live';
        clearInterval(timer);
      }
    }
    var timer = setInterval(tick, 1000);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tick);
    else tick();
  })();

  /* ---- pre-order close (html[data-store="closed"], snippets/harm-head.liquid) ---- */
  // Counts down to the close on [data-harm-closedown] and flips the page closed the second
  // pre-orders end; the head script then blocks buying.

  (function closer() {
    var close = window.HARM_CLOSE;
    if (!close || isNaN(close) || document.documentElement.dataset.store === 'closed') return;
    function pad(n) {
      return String(n).padStart(2, '0');
    }
    function tick() {
      var s = Math.max(0, Math.floor((close - Date.now()) / 1000));
      var text = 'T-' + pad(Math.floor(s / 86400)) + 'D ' + pad(Math.floor(s / 3600) % 24) + ':' + pad(Math.floor(s / 60) % 60) + ':' + pad(s % 60);
      document.querySelectorAll('[data-harm-closedown]').forEach(function (el) {
        el.textContent = text;
      });
      if (s === 0) {
        document.documentElement.dataset.store = 'closed';
        clearInterval(timer);
      }
    }
    var timer = setInterval(tick, 1000);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tick);
    else tick();
  })();

  /* ---- layering: keep the CRT layer and reticle above dialogs ----------------- */

  // Modal dialogs (cart drawer, quick-add, search) render in the browser's top layer, above any
  // z-index. Ride the top layer as manual popovers and re-raise whenever a dialog opens.
  var raised = [];
  function raise(el) {
    if (!el || typeof el.showPopover !== 'function') return;
    if (!el.hasAttribute('popover')) el.setAttribute('popover', 'manual');
    if (raised.indexOf(el) < 0) raised.push(el);
    try {
      if (el.matches(':popover-open')) el.hidePopover();
      el.showPopover();
    } catch (e) {}
  }
  function raiseAll(dialog) {
    // Exception: the product image lightbox shows the designs exactly as they are, so the
    // display layer (LCD grid, vignette) stays underneath it. Only the cursor rides above.
    var lightbox = dialog && dialog.matches('.dialog-zoomed-gallery__dialog');
    raised.forEach(function (el) {
      if (lightbox && el.classList.contains('harm-crt')) return;
      raise(el);
    });
  }
  function watchDialogs() {
    raise(document.querySelector('.harm-crt'));
    new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) {
        var t = list[i].target;
        if (t.nodeName === 'DIALOG' && t.hasAttribute('open')) {
          requestAnimationFrame(function () {
            raiseAll(t);
          });
          return;
        }
      }
    }).observe(document.body, { subtree: true, attributes: true, attributeFilter: ['open'] });
  }
  if (document.body) watchDialogs();
  else document.addEventListener('DOMContentLoaded', watchDialogs);

  /* ---- image flip on merch tiles (home + catalog) ---------------------------- */

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('[data-harm-flip]');
    if (!btn) return;
    var media = btn.closest('.harm-unit__media');
    var next = media.dataset.view === '1' ? '2' : '1';
    media.dataset.view = next;
    btn.setAttribute('aria-pressed', String(next === '2'));
    btn.querySelector('[data-flip-label]').textContent = next === '1' ? '02' : '01';
  });

  /* ---- ENLIST: editing the address after an answer clears it ----------------- */
  // The answer (sections/harm-footer.liquid) hides the CHANNEL LOCKED tag; typing again
  // removes it so the field reads as locked again and the note returns. Same as harm.icu.

  document.addEventListener('input', function (e) {
    var input = e.target && e.target.closest && e.target.closest('.harm-enlist__input');
    var form = input && input.form;
    var state = form && form.querySelector('[data-enlist-state]');
    if (!state) return;
    state.remove();
    var answer = form.querySelector('.harm-enlist__answer');
    if (answer) answer.remove();
  });

  /* ---- reticle (fine pointers only) ------------------------------------------ */

  if (!fine) return;

  // A target's drawn box. Shopify card links are display: contents (a 0x0 box at 0,0, which sent
  // the brackets to the top-left corner): use the union of their children, else the nearest sized
  // ancestor.
  function rectOf(el) {
    // Header menu links fill the whole 67px bar; lock onto the label, like harm.icu's site nav.
    var label = el.querySelector('.menu-list__link-title');
    if (label) el = label;
    var r = el.getBoundingClientRect();
    if (r.width >= 1 && r.height >= 1) return [r.left, r.top, r.right, r.bottom];
    var box = null;
    for (var i = 0; i < el.children.length; i++) {
      var c = el.children[i].getBoundingClientRect();
      if (c.width < 1 || c.height < 1) continue;
      box = box ? [Math.min(box[0], c.left), Math.min(box[1], c.top), Math.max(box[2], c.right), Math.max(box[3], c.bottom)] : [c.left, c.top, c.right, c.bottom];
    }
    if (box) return box;
    return el.parentElement ? rectOf(el.parentElement) : null;
  }

  function pad4(n) {
    return String(Math.max(0, Math.round(n))).padStart(4, '0');
  }

  function mountReticle() {
    var html = document.documentElement;
    var el = document.createElement('div');
    el.className = 'harm-reticle';
    el.setAttribute('aria-hidden', 'true');
    el.innerHTML =
      '<span class="harm-reticle__cross"><i class="harm-reticle__h"></i><i class="harm-reticle__v"></i></span>' +
      '<i class="harm-reticle__c harm-reticle__c--tl"></i><i class="harm-reticle__c harm-reticle__c--tr"></i>' +
      '<i class="harm-reticle__c harm-reticle__c--bl"></i><i class="harm-reticle__c harm-reticle__c--br"></i>' +
      '<span class="harm-reticle__read"></span>';
    document.body.appendChild(el);
    raise(el);

    var cross = el.querySelector('.harm-reticle__cross');
    var read = el.querySelector('.harm-reticle__read');
    var corners = Array.prototype.slice.call(el.querySelectorAll('.harm-reticle__c'));
    var x = -100;
    var y = -100;
    var visible = false;
    var target = null;
    var text = '';
    var cur = corners.map(function () {
      return [x, y];
    });

    window.addEventListener(
      'pointermove',
      function (e) {
        if (e.pointerType !== 'mouse') return;
        x = e.clientX;
        y = e.clientY;
        if (!visible) {
          visible = true;
          el.setAttribute('data-on', '');
          cur.forEach(function (c) {
            c[0] = x;
            c[1] = y;
          });
        }
      },
      { passive: true }
    );
    document.addEventListener('pointerover', function (e) {
      target = (e.target && e.target.closest && e.target.closest('a[href], button, label, summary, select')) || null;
      el.toggleAttribute('data-lock', !!target);
    });
    html.addEventListener('pointerleave', function () {
      visible = false;
      el.removeAttribute('data-on');
    });
    html.classList.add('has-reticle');

    // Every frame (no throttle: skipping frames on 120Hz screens made the lock lag), with a
    // time-based ease so the brackets reach their target in about 4 frames at any refresh rate.
    var lastFrame = 0;
    function frame(now) {
      requestAnimationFrame(frame);
      var dt = lastFrame ? Math.min(now - lastFrame, 100) : 16.7;
      lastFrame = now;
      if (!visible || document.hidden) return;
      cross.style.transform = 'translate3d(' + x + 'px,' + y + 'px,0)';
      var box;
      var tr = target && target.isConnected ? rectOf(target) : null;
      if (tr) {
        box = [tr[0] - 4, tr[1] - 4, tr[2] + 4, tr[3] + 4];
      } else {
        box = [x - 10, y - 10, x + 10, y + 10];
      }
      var goal = [
        [box[0], box[1]],
        [box[2], box[1]],
        [box[0], box[3]],
        [box[2], box[3]],
      ];
      var k = reduced ? 1 : 1 - Math.pow(0.4, dt / 16.7);
      corners.forEach(function (c, i) {
        var p = cur[i];
        p[0] += (goal[i][0] - p[0]) * k;
        p[1] += (goal[i][1] - p[1]) * k;
        c.style.transform = 'translate3d(' + p[0].toFixed(1) + 'px,' + p[1].toFixed(1) + 'px,0)';
      });
      var next = target ? '[TGT LOCK]' : 'X' + pad4(x) + ' Y' + pad4(y);
      if (next !== text) {
        text = next;
        read.textContent = next;
      }
      read.style.transform = 'translate3d(' + (x + 16) + 'px,' + (y + 14) + 'px,0)';
    }
    requestAnimationFrame(frame);
  }

  if (document.body) mountReticle();
  else document.addEventListener('DOMContentLoaded', mountReticle);
})();
